import { gql } from '@apollo/client';

const LogPaymentSecurityEvent = gql`
  mutation LogPaymentSecurityEvent($input: PaymentSecurityEventInput!) {
    logPaymentSecurityEvent(input: $input) {
      success
      message
    }
  }
`;

export default LogPaymentSecurityEvent;
